<div>
  <div id="rechnungenKopf">
    <div class="rechnungenKopf">
      <strong>Datum</strong>
      <strong>Rechungszeitraum</strong>
      <strong>Nummer</strong>
      <strong>Betrag</strong>
      <strong>Status der Rechnung</strong>
      <strong>Rechnungen Anfordern</strong>
    </div>
  </div>

  <div *ngFor="let rechnung of rechnungen" class="rechnungenContent">
    <div class="rechnungenKopf">
      <span> {{rechnung.datum | date:'dd.MM.YYYY'}}</span>
      <span>{{rechnung.zeitraum[0] * 1000 | date:'dd.MM.YYYY'}} - {{rechnung.zeitraum[1] * 1000 | date:'dd.MM.YYYY'}}</span>
      <span>{{rechnung.nr}}</span>
      <span [ngClass]="rechnung.offen ? 'nichtBeglichen' : 'beglichen'" >{{rechnung.betrag}}</span>
      <span [ngClass]="rechnung.offen ? 'nichtBeglichen' : 'beglichen'" >{{ !rechnung.offen ? 'Betrag bezahlt' : 'Betrag offen'}}</span>
      <div (click)="rechnungAnfordern(rechnung.nr)">
        <mat-icon [matTooltip]="'Rechnung anfordern'" >mail</mat-icon>
      </div>
    </div>
  </div>
</div>
